import { Button } from '@mui/material'

type Props = {
  loading?: boolean
}

export const SearchButton = ({ loading = false }: Props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Button fullWidth loading={loading} variant="contained" color="primary" type="submit" sx={{ minWidth: 125 }}>
        Search
      </Button>
    </div>
  )
}
